import actions from '../../actions';
import { handleActions } from 'redux-actions';
import produce from 'immer';
//{
//    cmds: [ { "cmd": "align" } ],
//    args: {
//      "probe-diameter": 0.15748031496062992
//    }
//  }
export const defaultState = {
  program: {
    "cmds": [
      { "cmd": "safety-move" },
      { "cmd": "align", "args": { "B": 45, "C": -30 } },
      { 
        "cmd": "probe-feature-tcpc", "args": {
        "feature": 0,
        "cmds": [
          { "cmd": "probe", "args": { "point": { "x": 2.853243841766013, "y": 2.1455961628542184, "z": 3.3020473618130315 }, "direction": { "x": -0.6123724579811096, "y": -0.3535534143447876, "z": 0.7071067690849304 }, "start-distance": 0.1, "end-distance": -0.05, "mode": "global-xy,z", "save": "touch-point" }},
          { "cmd": "probe", "args": { "point": { "x": 4.083696940715091, "y": 0.890789694062458, "z": 3.7402477662148574 }, "direction": { "x": -0.6123724579811096, "y": -0.3535534143447876, "z": 0.7071067690849304 }, "start-distance": 0.1, "end-distance": -0.05, "mode": "global-xyz", "save": "touch-point" }},
          { "cmd": "probe", "args": { "point": { "x": 3.685847132642136, "y": 0.30359174175112935, "z": 3.10210065216611 }, "direction": { "x": -0.6123724579811096, "y": -0.35355344414711, "z": 0.7071067094802856 }, "start-distance": 0.1, "end-distance": -0.05, "mode": "global-xyz", "save": "touch-point" } }
        ]}
      },
      { 
        "cmd": "probe-feature-tcpc", "args": {
        "feature": 1,
        "cmds": [
          { "cmd": "move", "args": { "point": { "x": 3.6434, "y": -0.5, "z": 3.0532 }, "mode": "global-xyz", "save": "touch-point" }},
          { "cmd": "probe", "args": { "point": { "x": 3.831367018638663, "y": -0.05267228807456979, "z": 2.8478603548624686 }, "direction": { "x": 0.5, "y": -0.8660253882408142, "z": -3.9656118389075345e-8 }, "start-distance": 0.1, "end-distance": -0.05, "mode": "global-xyz", "save": "touch-point" }},
          { "cmd": "probe", "args": { "point": { "x": 4.626234628447005, "y": 0.40624476728282255, "z": 3.7630501405840926 }, "direction": { "x": 0.4999997317790985, "y": -0.8660255670547485, "z": 3.74215403553535e-7 }, "start-distance": 0.1, "end-distance": -0.05, "mode": "global-xyz", "save": "touch-point" }}
        ]}
      },
      { 
        "cmd": "probe-feature-tcpc", "args": {
        "feature": 2,
        "cmds": [
          { "cmd": "move", "args": { "point": { "x": 5, "y": 0.4, "z": 4.1 }, "mode": "global-xyz", "save": "touch-point" }},
          { "cmd": "probe", "args": { "point": { "x": 4.641935932874397, "y": 0.7205010075755965, "z": 3.9588489316654387 }, "direction": { "x": 0.6123720407485962, "y": 0.3535532057285309, "z": 0.7071071863174438 }, "start-distance": 0.1, "end-distance": -0.05, "mode": "global-xyz", "save": "touch-point" }},
          { "cmd": "probe", "args": { "point": { "x": 3.3685624224693522, "y": 2.9430087389489805, "z": 3.950368852713906 }, "direction": { "x": 0.6123719215393066, "y": 0.3535531163215637, "z": 0.7071073651313782 }, "start-distance": 0.1, "end-distance": -0.05, "mode": "global-xyz", "save": "touch-point" }}
        ]}
      },
      { "cmd": "safety-move" },
      { "cmd": "project-points-onto-plane", "args": { "plane": 0, "points": 1, "output": 3 } },
      { "cmd": "project-points-onto-plane", "args": { "plane": 0, "points": 2, "output": 4 } },
      { "cmd": "intersect-lines", "args": { "line1": 3, "line2": 4, "output": 5 } },
      { "cmd": "set-g5x-offset", "args": { "g5x-index": 2, "feature": 5, "method": "first" } }
    ],
    "args": {
      "probe-diameter": 0.15748031496062992
    }
  },
  activeOperation: -1,
  highlightedOperation: -1
};

export const reducer = handleActions(
  {
    [actions.probing.setHighlightedOperation]: produce((state, action) => { 
      state.highlightedOperation = action.payload;
    }),
    [actions.probing.setActiveOperation]: produce((state, action) => { 
      state.activeOperation = action.payload;
    }),
    [actions.probing.updateOperation]: produce((state,action) => {
      const {
        index,
        object
      } = action.payload;
      state.program.cmds[index] = { ...state.program.cmds[index], ...object };
    })
  },
  defaultState
);

export default reducer;
